export async function previewFileToBlob(previewUrl: string) {
  try {
    const response = await fetch(previewUrl);
    if (!response.ok) {
      return Promise.reject('Preview file to blob failed');
    }
    const blob = await response.blob();
    return blob;
  } catch (error) {
    return Promise.reject(error);
  }
}

// blob转为base64
export const blobToBase64 = (blob: Blob) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result;
      if (typeof result === 'string') {
        resolve(result);
      } else {
        reject(new Error('Unexpected FileReader result type'));
      }
    };
    reader.onerror = () => {
      reject(reader.error || new Error('Failed to read blob as data URL'));
    };
    reader.readAsDataURL(blob);
  });